
import "../../styles/footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__overlay" />

      <div className="footer__content">
        <h2 className="footer__logo">
          LA ESQUINA <span>DEL PARQUES</span>
        </h2>

        <p className="footer__subtitle">
          BAR • GASTROBAR • SABOR Y BUENOS MOMENTOS
        </p>

        <div className="footer__line" />

        <p className="footer__copy">
          © {new Date().getFullYear()} La Esquina del Parques
          {" "}— Todos los derechos reservados
        </p>
      </div>
    </footer>
  );
}
